import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { CreateFundingRequestBody } from "@shared-kernel/application/ports/student/student-repository";

export const createFundingRequest = createApiThunk<string, CreateFundingRequestBody>(
  "fundingRequests/createFundingRequest",
  async (fundingRequest, { extra: { studentRepository } }) => {
    return studentRepository!.createFundingRequest(fundingRequest);
  },
);

export const resetCreateFundingRequest = createAction("fundingRequests/resetCreateFundingRequest");
